import {Decoder, equal, oneOf} from 'json-bouncer'

export type InquiryStatusType = 'offerStatus' | 'proofCopyStatus'

export function inquiryStatusTypeDecoder(): Decoder<InquiryStatusType> {
    const offer: InquiryStatusType = 'offerStatus'
    const proofCopy: InquiryStatusType = 'proofCopyStatus'
    return oneOf([
        equal(offer),
        equal(proofCopy)
    ])
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InquiryStatusType.ts